import React from "react";

/** Inline SVG flags — crisp at any size, consistent across OSes (unlike emoji). */

function FlagDE({ className }) {
  return (
    <svg
      viewBox="0 0 5 3"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      className={className}
    >
      <rect width="5" height="1" y="0" fill="#000000" />
      <rect width="5" height="1" y="1" fill="#DD0000" />
      <rect width="5" height="1" y="2" fill="#FFCE00" />
    </svg>
  );
}

function FlagGB({ className }) {
  return (
    <svg
      viewBox="0 0 60 30"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      className={className}
    >
      <clipPath id="mh-gb-clip">
        <path d="M0,0 v30 h60 v-30 z" />
      </clipPath>
      <g clipPath="url(#mh-gb-clip)">
        <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFFFFF" strokeWidth="6" />
        <path
          d="M0,0 L60,30 M60,0 L0,30"
          stroke="#C8102E"
          strokeWidth="4"
          clipPath="url(#mh-gb-clip)"
        />
        <path
          d="M30,0 v30 M0,15 h60"
          stroke="#FFFFFF"
          strokeWidth="10"
        />
        <path
          d="M30,0 v30 M0,15 h60"
          stroke="#C8102E"
          strokeWidth="6"
        />
      </g>
    </svg>
  );
}

const FLAGS = { de: FlagDE, gb: FlagGB };

export function FlagIcon({ flag, className = "" }) {
  const F = FLAGS[flag] || FlagDE;
  return <F className={className} />;
}
